// src/components/Services.js
import React from 'react';
import './style.css';
import sercon from "../../assests/Services/sercons.png";
import serde from "../../assests/Services/serde.png";
import serac from "../../assests/Services/serac.png";
import serpai from "../../assests/Services/serpai.png";
import serele from "../../assests/Services/serele.png";
import sercctv from "../../assests/Services/sercctv.png";
import serdig from "../../assests/Services/serdig.png";
import { useNavigate } from "react-router-dom";

const services = [
    {
        title: 'CONSTRUCTION SERVICES',
        description: 'Comprehensive construction solutions including residential, commercial, and industrial projects — built with precision and quality.',
        icon: sercon,
    },
    {
        title: 'DEMOLITION SERVICES',
        description: 'Safe, efficient, and controlled demolition for buildings and structures, handled with strict safety protocols.',
        icon: serde,
    },
    {
        title: 'AC SERVICES',
        description: 'Expert air conditioning installation, maintenance, and repair for both residential and commercial spaces.',
        icon: serac,
    },
    {
        title: 'PAINTING & TILING',
        description: 'High-quality interior and exterior painting, along with professional tiling services for floors and walls.',
        icon: serpai,
    },
    {
        title: 'ELECTRICAL SERVICES',
        description: 'Certified electrical work including wiring, lighting, panel installation, and fault diagnostics.',
        icon: serele,
    },
    {
        title: 'SECURITY SYSTEMS',
        description: 'Installation and maintenance of CCTV, access control, and alarm systems to ensure safety and surveillance.',
        icon: sercctv,
    },
    {
        title: 'DIGITAL MARKETING',
        description: 'Targeted digital marketing strategies to grow your business online — SEO, social media, and branding.',
        icon: serdig,
    },
];




const Services = () => {
    const navigate = useNavigate();
    const handleInfo = () => {
        navigate("/our-services"); // This will navigate to About Us and include the hash
    };
    return (
        <div className="services-section">
            <h2>Our Services</h2>
            <p className="subtitle">
                Your Vision, Our Mission — From Foundation to Finish.
            </p>


            <div className="services-grid">
                {services.map((service, index) => (
                    <div className="service-card" key={index}>
                        <div className="gif-wrapper">

                        </div>

                        <div className="service-icon">
                            <img src={service.icon} alt={service.title} className="icon-image" />
                        </div>

                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>

                ))}
            </div>
            <div className="neumorphic-button-wrapper">
                <div onClick={handleInfo} className="neumorphic-button">MORE INFO</div>
            </div>

        </div>
    );
};

export default Services;
